import React, { useEffect, useState } from "react";
import { MdOutlineCancel, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { Button } from ".";
import { userProfileData } from "../data/dummy";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import UserService from "../services/userService";
import userService from "../services/userService";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Loading from "./Loading";
import { toast, ToastContainer } from "react-toastify";

const UserProfile = ({ setIsLogged }) => {
  const navigate = useNavigate();
  const { currentColor, currentMode } = useStateContext();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [userData, setUserData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const togglePasswordVisibility = (type) => {
    switch (type) {
      case "current":
        setShowCurrentPassword((prevState) => !prevState);
        break;
      case "new":
        setShowNewPassword((prevState) => !prevState);
        break;
      case "confirm":
        setShowConfirmPassword((prevState) => !prevState);
        break;
      default:
        break;
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (newPassword.length < 16) {
      newErrors.newPassword =
        "New password must be at least 16 characters long.";
    }
    if (newPassword !== confirmNewPassword) {
      newErrors.confirmNewPassword =
        "Confirm password does not match new password.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateNewPassword = (password) => {
    const errors = {};
    if (password.length < 16) {
      errors.newPassword = "New password must be at least 16 characters long.";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/g.test(password)) {
      errors.newPassword =
        "New password must contain at least one special character.";
    }
    setErrors(errors);
  };

  const validateConfirmPassword = (password) => {
    if (password !== newPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmNewPassword: "Confirm password does not match new password.",
      }));
    } else {
      setErrors((prev) => {
        const { confirmNewPassword, ...rest } = prev;
        return rest;
      });
    }
  };

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      setUserData(JSON.parse(userDataString));
      console.log(userData, "USER----");
    }
  }, []);

  const filteredUserProfileData = userProfileData.filter(
    (item) =>
      item.title !== "My Profile" &&
      item.title !== "My Tasks" &&
      item.title !== "My Inbox"
  );

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("accesstoken");
    localStorage.removeItem("refreshtoken");
    localStorage.removeItem("expires_in");
    window.location.href = "/";
  };

  const handleUpdatePassword = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      if (
        Object.keys(errors).length === 0 &&
        newPassword &&
        confirmNewPassword
      ) {
        const updatepas = await userService.updatePassword(userData._id, {
          currentPwd: currentPassword,
          password: newPassword,
        });

        if (updatepas) {
          setLoading(false);
          toast.success("Password updated successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.warning(
            `${updatepas.message}` || "Failed to update the password",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
        setErrors({});
        setLoading(false);
        setIsModalOpen(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleModalClose = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
    setErrors({});
    setIsModalOpen(false);
  };

  return (
    <div
      className={`nav-item absolute right-1 top-16 p-8 rounded-lg w-96 ${
        currentMode === "Dark" ? "bg-[#33373E] text-white" : "bg-white"
      }`}
    >
      <div className="flex justify-between items-center">
        <p
          className={`font-semibold text-lg ${
            currentMode === "Dark" ? "text-gray-200" : "text-gray-800"
          }`}
        >
          User Profile
        </p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        {userData && (
          <div>
            <p
              className={`font-semibold text-xl ${
                currentMode === "Dark" ? "text-gray-200" : "text-gray-800"
              }`}
            >
              {userData.firstname} {userData.lastname}
            </p>
            <p
              className={`text-sm ${
                currentMode === "Dark" ? "text-gray-400" : "text-gray-500"
              }`}
            >
              {userData.email}
            </p>
            <p
              className={`text-sm ${
                currentMode === "Dark" ? "text-gray-400" : "text-gray-500"
              }`}
            >
              {userData.role}
            </p>
          </div>
        )}
      </div>
      <div className="flex justify-between mt-4">
        <p
          className={`text-sm cursor-pointer ${
            currentMode === "Dark" ? "text-gray-400" : "text-gray-500"
          }`}
          onClick={() => setIsModalOpen(true)}
        >
          Change Password
        </p>
        {isModalOpen && (
          <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center">
            <div className="absolute bg-black opacity-50 inset-0"></div>
            <div
              className={`z-50 p-8 rounded-lg w-96 ${
                currentMode === "Dark" ? "bg-[#42464D] text-white" : "bg-white"
              }`}
            >
              <h2 className="text-xl font-semibold mb-4">Change Password</h2>
              <form onSubmit={handleUpdatePassword}>
                <div className="mb-4 relative">
                  <label className="block text-sm font-semibold">
                    Current Password
                  </label>
                  <div className="relative">
                    <input
                      type={showCurrentPassword ? "text" : "password"}
                      placeholder="Current Password"
                      className={`border p-2 rounded w-full ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility("current")}
                      className="absolute inset-y-0 right-0 flex items-center justify-center px-3"
                    >
                      {showCurrentPassword ? (
                        <MdVisibilityOff />
                      ) : (
                        <MdVisibility />
                      )}
                    </button>
                  </div>
                </div>

                <div className="mb-4 relative">
                  <label className="block text-sm font-semibold mb-2">
                    New Password
                  </label>
                  <div className="relative">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className={`border p-2 rounded w-full ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        validateNewPassword(e.target.value);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility("new")}
                      className="absolute inset-y-0 right-0 flex items-center justify-center px-3"
                    >
                      {showNewPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </button>
                    {errors.newPassword && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.newPassword}
                      </p>
                    )}
                  </div>
                </div>

                <div className="mb-4 relative">
                  <label className="block text-sm font-semibold">
                    Confirm New Password
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className={`border p-2 rounded w-full ${
                        currentMode === "Dark"
                          ? "bg-[#33373E] text-white"
                          : "bg-white text-gray-800"
                      }`}
                      placeholder="Confirm New Password"
                      value={confirmNewPassword}
                      onChange={(e) => {
                        setConfirmNewPassword(e.target.value);
                        validateConfirmPassword(e.target.value);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility("confirm")}
                      className="absolute inset-y-0 right-0 flex items-center justify-center px-3"
                    >
                      {showConfirmPassword ? (
                        <MdVisibilityOff />
                      ) : (
                        <MdVisibility />
                      )}
                    </button>
                    {errors.confirmNewPassword && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.confirmNewPassword}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex justify-start">
                  <button
                    type="submit"
                    className="px-4 py-2 bg-gray-800 text-white rounded-full hover:bg-gray-700 focus:outline-none focus:shadow-outline mr-10"
                    style={{ backgroundColor: currentColor }}
                  >
                    Update Password
                  </button>
                  <button
                    type="button"
                    className="ml-2 px-4 py-2 bg-gray-300 text-gray-800 rounded-full hover:bg-gray-400 focus:outline-none focus:shadow-outline"
                    onClick={() => {
                      handleModalClose();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <div>
        {filteredUserProfileData.map((item, index) => (
          <div
            key={index}
            className={`flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer ${
              currentMode === "Dark"
                ? "dark:hover:bg-[#42464D]"
                : "hover:bg-light-gray"
            }`}
          >
            <button
              type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg }}
              className="text-xl rounded-lg p-3"
            >
              {item.icon}
            </button>
            <div>
              <p
                className={`font-semibold ${
                  currentMode === "Dark" ? "text-gray-200" : "text-gray-800"
                }`}
              >
                {item.title}
              </p>
              <p
                className={`text-sm ${
                  currentMode === "Dark" ? "text-gray-400" : "text-gray-500"
                }`}
              >
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6">
        <button
          onClick={handleLogout}
          style={{ backgroundColor: currentColor, color: "white" }}
          className="my-0 w-full item-center flex justify-center p-2 rounded-full tracking-wide font-semibold focus:outline-none focus:shadow-outline shadow-lg cursor-pointer transition ease-in duration-300"
        >
          Logout
        </button>
      </div>
      <ToastContainer />
      {loading && <Loading loading={"Updating"} currentColor={currentColor} />}
    </div>
  );
};

export default UserProfile;
